import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Rocket, BookOpen } from 'lucide-react';
import Logo from '../common/Logo';

export default function Header() {
  return (
    <header className="bg-black/95 text-white backdrop-blur-sm fixed w-full z-50">
      <div className="container mx-auto px-4 py-4">
        <nav className="flex items-center justify-between">
          <Logo className="hover:opacity-90 transition-opacity" />
          <div className="flex items-center space-x-8">
            <Link to="/bitcoin-basics" className="flex items-center space-x-2 hover:text-purple-400 transition-colors">
              <BookOpen className="w-5 h-5" />
              <span>Bitcoin Basics</span>
            </Link>
            <Link to="/locations" className="flex items-center space-x-2 hover:text-purple-400 transition-colors">
              <MapPin className="w-5 h-5" />
              <span>Find BTMs</span>
            </Link>
            <Link to="/host" className="flex items-center space-x-2 hover:text-purple-400 transition-colors">
              <Rocket className="w-5 h-5" />
              <span>Host a BTM</span>
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
}